import { render, staticRenderFns } from "./AboutMe.vue?vue&type=template&id=3e215ae1&scoped=true&"
import script from "./AboutMe.vue?vue&type=script&lang=js&"
export * from "./AboutMe.vue?vue&type=script&lang=js&"
import style0 from "./AboutMe.vue?vue&type=style&index=0&id=3e215ae1&lang=scss&scoped=true&"
import style1 from "./AboutMe.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e215ae1",
  null
  
)

export default component.exports